/**
 * Utility module to implement debouncing when user searches a string.
 * @module src/util/debounced
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
export interface Debounced {
  (...args: any): void;
  cancel: () => void;
}

const debounced = (delay: number, fn: (...args: any) => void): Debounced => {
  let timerId: any;
  const debouncedFn = (...args: any): void => {
    if (timerId !== null) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  };
  debouncedFn.cancel = (): void => {
    if (timerId !== null) {
      clearTimeout(timerId);
      timerId = null;
    }
  };
  return debouncedFn;
};

/** Module to implement debouncing */
export default debounced;

